import React, { createContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './pages/SearchResults.css';

export const AdminAuthContext = createContext();
export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const refreshAdminToken = async () => {
    const refreshToken = localStorage.getItem('admin_refresh_token');
    if (!refreshToken) {
      return false;
    }

    try {
      const response = await fetch('https://valleyapi-dr9y.onrender.com/api/admin-refresh-token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Failed to refresh admin token');
      }

      localStorage.setItem('admin_token', data.token);
      if (data.refreshToken) {
        localStorage.setItem('admin_refresh_token', data.refreshToken);
      }
      if (data.user) {
        localStorage.setItem('admin_user', JSON.stringify(data.user));
        setAdmin(data.user);
      }
      return true;
    } catch (err) {
      return false;
    }
  };

  const verifyAdmin = async () => {
    const storedToken = localStorage.getItem('admin_token');
    const storedAdmin = localStorage.getItem('admin_user');

    if (storedToken && storedAdmin && storedAdmin !== 'undefined') {
      try {
        const parsedAdmin = JSON.parse(storedAdmin);
        if (parsedAdmin.role !== 'admin') {
          logout();
          return;
        }
        const response = await fetch('https://valleyapi-dr9y.onrender.com/api/verify-token', {
          headers: { 'Authorization': `Bearer ${storedToken}` },
        });
        const data = await response.json();
        if (response.ok && data.valid && data.user.role === 'admin') {
          const verifiedAdmin = { ...parsedAdmin, ...data.user };
          localStorage.setItem('admin_user', JSON.stringify(verifiedAdmin));
          setAdmin(verifiedAdmin);
        } else {
          const refreshed = await refreshAdminToken();
          if (!refreshed) {
            logout();
          }
        }
      } catch (error) {
        const refreshed = await refreshAdminToken();
        if (!refreshed) {
          logout();
        }
      }
    } else {
      // No hay token o usuario, simplemente establecer admin como null
      setAdmin(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    verifyAdmin();
    const interval = setInterval(verifyAdmin, 30 * 60 * 1000); // Check every 30 minutes
    return () => clearInterval(interval);
  }, []);

  const login = ({ token, refreshToken, user }) => {
    if (!token || !user || user.role !== 'admin') {
      console.error('AdminAuth: Datos de login inválidos:', { token, user });
      return;
    }
    setAdmin(user);
    localStorage.setItem('admin_token', token);
    if (refreshToken) {
      localStorage.setItem('admin_refresh_token', refreshToken);
    }
    localStorage.setItem('admin_user', JSON.stringify(user));
  };

  const logout = () => {
    setAdmin(null);
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_refresh_token');
    localStorage.removeItem('admin_user');
    localStorage.removeItem('user_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_user');

    // Solo redirigir a /admin-login si la ruta actual es una ruta de administrador
    if (location.pathname.startsWith('/admin')) {
      navigate('/admin-login', { replace: true });
    }
  };

  
  const isAdminRoute = location.pathname.startsWith('/admin');

if (loading && isAdminRoute) {
    return (
      <div>
        <div className="search-results-loading">
          <div className="search-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout, loading }}>
      {children}
    </AdminAuthContext.Provider>
  );
}
